import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  ERevenueSortField,
  IRevenue,
  PRevenueFilter,
} from "src/core/revenue/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IRevenueState {
  revenues: IRevenue[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IRevenueState = {
  revenues: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "revenue/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "revenue/FETCH_SUCCEEDED";
const FETCH_FAILED = "revenue/FETCH_FAILED";
const POLLING_START_REQUESTED = "revenue/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "revenue/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IRevenue[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PRevenueFilter;
    pagination: IPagination;
    sorts: ISort<ERevenueSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IRevenueState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IRevenueState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.revenues = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
